module.exports = __webpack_public_path__ + "img/club_foreground.d8a8fb4c.png";